// extracted by mini-css-extract-plugin
module.exports = {"tools":"Bf1FzL","tool":"Gn9VFk","caption":"GOiqJo","figure":"UG0aq2","image":"_28y5As"};